export var Translations = {
  en: {
    login_page:                {
      welcome:                       'Welcome back',
      dont_have_account:             'Don\'t have account?',
      create_account:                'Create an account',
      login_button:                  'Sign in',
      email_label:                   'Email',
      email_placeholder:             'name@company.com',
      password_label:                'Password',
      password_placeholder:          'password',
      code_label:                    'Two-factor authentication code',
      code_placeholder:              '123456',
      login_error_wrong_credentials: 'Incorrect log in credentials. Type correct credentials and try again.',
    },
    sfa_form:                  {
      modal_title:                      'Set up two-factor authentication',
      modal_ok:                         'OK',
      modal_cancel:                     'Cancel',
      label_1:                          '1. Scan the QR code with your authenticator app',
      label_2:                          '2. Enter the code from your authenticator app',
      label_3:                          'Write down the following backup codes, they will be used to confirm your log in if you lose your authenticator app. Any of backup codes can be used only once to log in, then you need to add new two-factor authentication.',
      label_4:                          'Clicking "OK" button will enable two-factor authentication for your account (you will be logged out and need to log in again).',
      confirm_backup_codes_success:     'Two-factor authentication set up successfully.',
      modal_input_placeholder_code:     'Enter the code',
      wrong_code:                       'The code you entered is incorrect.',
      wrong_confirm_process:            'Something went wrong, please try again later.',
      remove_2fa:                       'Disable two-factor authentication',
      remove_2fa_success:               'Two-factor authentication disabled.',
      modal_confirm_delete_2fa_title:   'Disable two-factor authentication',
      modal_confirm_delete_2fa_content: 'Are you sure you want to disable two-factor authentication?',
    },
    ads_page:                  {
      page_header_title:       'Ads',
      add_new_adschedule_cta:  'Add new ad schedule',
      col_t_name:              'Name',
      col_t_standard:          'Standard',
      col_t_format:            'Format',
      col_t_actions:           'Actions',
      actions_edit:            'Edit',
      actions_delete:          'Delete',
      modal_confirm_delete_t:  'Delete',
      modal_confirm_delete_c:  'Are you sure you want to delete',
      modal_confirm_delete_ok: 'ad deleted.',
    },
    embed_page:                {
      added:                    'Embed added.',
      changes_saved:            'Changes saved.',
      page_header_title:        'Embed codes',
      add_new_embed:            'Generate embed code',
      col_t_name:               'Name',
      col_t_player:             'Player',
      col_t_ad:                 'Ad',
      col_t_video:              'Video',
      col_t_playlist:           'Playlist',
      col_t_created:            'Created',
      col_t_modified:           'Modified',
      col_t_actions:            'Actions',
      actions_edit:             'Edit',
      actions_delete:           'Delete',
      modal_confirm_delete_t:   'Delete',
      modal_confirm_delete_c:   'Are you sure you want to delete',
      modal_confirm_delete_ok:  'embed deleted.',
      get_embed_code_link:      'Get code',
      button_copy_code:         'Get code',
      notification_code_copied: 'Code snippet copied to clipboard.',
    },
    embed_form:                {
      page_header_title_add:        'New embed code',
      modal_confirm_delete_t:       'Delete',
      modal_confirm_delete_c:       'Are you sure you want to delete',
      modal_confirm_delete_ok:      'embed code deleted.',
      page_header_action_delete:    'Delete',
      page_header_action_cancel:    'Cancel',
      page_header_action_save:      'Save',
      page_header_action_close:     'Close',
      input_l_name:                 'Embed code name',
      input_l_player:               'Player',
      input_l_code:                 'Code snippet',
      toggle_l_type:                'Item',
      input_l_video:                'Video',
      input_l_placeholder_player:   'Select player',
      input_l_placeholder_video:    'Select video',
      input_l_placeholder_playlist: 'Select playlist',
      input_l_playlist:             'Playlist',
      button_generate_code:         'Generate embed code',
      button_copy_code:             'Copy',
      notification_code_copied:     'Code snippet copied to clipboard.',
    },
    playlists_page:            {
      page_header_title:       'Playlists',
      add_new_playlist:        'Add new playlist',
      sort_date_asc:           'From oldest to newest created',
      sort_date_desc:          'From newest to oldest created',
      sort_random:             'Random',
      col_t_name:              'Name',
      col_t_sort:              'Sort type',
      col_t_created:           'Created',
      col_t_actions:           'Actions',
      actions_edit:            'Edit',
      actions_delete:          'Delete',
      modal_confirm_delete_t:  'Delete',
      modal_confirm_delete_c:  'Are you sure you want to delete',
      modal_confirm_delete_ok: 'playlist deleted.',
      playlist_added:          'Playlist added.',
      changes_saved:           'Playlist saved.',
    },
    playlist_form:             {
      input_action_delete:              'Delete',
      page_header_title_add:            'New playlist',
      modal_confirm_delete_t:           'Delete',
      modal_confirm_delete_c:           'Are you sure you want to delete',
      modal_confirm_delete_ok:          'Playlist deleted.',
      page_header_action_delete:        'Delete',
      page_header_action_cancel:        'Cancel',
      page_header_action_save:          'Save',
      input_l_name:                     'Playlist name',
      sort_l_name:                      'Playlist playback order',
      sort_random:                      'Random',
      sort_date_asc:                    'By creation date (from oldest to newest created)',
      sort_date_desc:                   'By creation date (from newest to oldest created)',
      video_panel:                      'Your videos',
      playlist_panel:                   'Playlist videos',
      items_l:                          'Item(s)',
      select_videos_validation_message: 'Please add videos to your playlist.',
    },
    users_page:                {
      page_header_title:          'Veedmo admin - clients\' accounts - BE CAREFUL',
      page_accounts_header_title: 'Veedmo admin - clients\' SUB - accounts - BE CAREFUL',
      add_new_user:               'Add new client',
      col_t_name:                 'Full name',
      col_t_username:             'Email',
      col_t_phone:                'Phone number',
      col_t_website:              'Website',
      col_t_last_login:           'Last login',
      col_t_role:                 'Role',
      col_t_2fa:                  '2FA',
      col_t_status:               'Status',
      col_t_actions:              'Actions',
      col_t_stats_last_month:     'Previous month ad impressions',
      col_t_stats_current_month:  'Current month ad impressions',
      actions_edit:               'Edit',
      actions_context:            'Account login',
      modal_confirm_context_t:    'Log in to another account',
      modal_confirm_context:      'You will be logged out from this account. Are you sure you want to log in to another client\'s account?',
    },
    accounts_page:             {
      page_header_title_admin: 'Veedmo admin - clients\' SUB - accounts - BE CAREFUL',
      page_header_title:       'Users',
      add_new_ad_cta:          'Add new user',
      col_t_name:              'Full name',
      col_t_parent:            'Parent Account',
      col_t_email:             'Email',
      col_t_permissions:       'Permissions',
      col_t_status:            'Status',
      col_t_2fa:               '2FA',
      col_t_settings:          'Settings',
      col_t_actions:           'Actions',
      actions_edit:            'Edit',
      actions_delete:          'Delete',
      modal_confirm_delete_t:  'Delete',
      modal_confirm_delete_c:  'Are you sure you want to delete',
      modal_confirm_delete_ok: 'account deleted.',

    },
    veedmo_settings_page:      {
      page_header_title: 'Veedmo admin - settings - BE CAREFUL',
      col_t_name:        'Name',
      col_t_value:       'Value',
      col_t_actions:     'Actions',
      actions_add:       'Add new setting',
      actions_edit:      'Edit',
      changes_saved:     'Changes saved.',
    },
    veedmo_settings_form:      {
      input_l_name:              'Name of setting',
      input_l_value:             'Value',
      page_header_action_cancel: 'Cancel',
      page_header_action_save:   'Save',
      page_header_title_add:     'Add new setting',
      setting_added:             'New setting added',

    },
    accounts_add_page:         {
      account_added: 'Account added.',
    },
    accounts_edit_page:        {
      changes_saved: 'Changes saved.',
    },
    users_add_page:            {
      added: 'New user added.',
    },
    users_edit_page:           {
      changes_saved: 'Changes saved.',
    },
    accounts_form:             {
      empty:                               '-',
      settings_daily_analytic_email:       'Send daily reports by email',
      page_header_title_add:               'New user',
      input_l_email:                       'Email',
      input_l_name:                        'Full name',
      input_l_roles:                       'Roles',
      input_l_password_placeholder:        'If left empty, password won\'t change',
      input_l_status:                      'Account status',
      input_l_password:                    'Password',
      input_l_settings:                    'Additional settings',
      input_l_permissions:                 'User permissions',
      page_header_action_cancel:           'Cancel',
      page_header_action_save:             'Save',
      status_active:                       'Active',
      status_inactive:                     'Inactive',
      permission_group_stats:              'Reports',
      permission_group_media:              'Media (videos/playlists)',
      permission_group_players:            'Players',
      permission_group_ads:                'Ads',
      permission_group_embeds:             'Embed codes',
      permission_group_accounts:           'Accounts management',
      permission_name_stats_read:          'Read',
      permission_name_ads_read:            'Read',
      permission_name_ads_write:           'Write',
      permission_name_ads_delete:          'Delete',
      permission_name_players_read:        'Read',
      permission_name_players_write:       'Write',
      permission_name_players_delete:      'Delete',
      permission_name_media_read:          'Read',
      permission_name_media_write:         'Write',
      permission_name_media_delete:        'Delete',
      permission_name_embeds_read:         'Read',
      permission_name_embeds_write:        'Write',
      permission_name_embeds_delete:       'Delete',
      permission_name_accounts_read:       'Read',
      permission_name_accounts_write:      'Write',
      permission_name_accounts_delete:     'Delete',
      permission_fullname_stats_read:      'Reports read',
      permission_fullname_ads_read:        'Ads read',
      permission_fullname_ads_write:       'Ads write',
      permission_fullname_ads_delete:      'Ads delete',
      permission_fullname_players_read:    'Players read',
      permission_fullname_players_write:   'Players write',
      permission_fullname_players_delete:  'Players delete',
      permission_fullname_media_read:      'Media read',
      permission_fullname_media_write:     'Media write',
      permission_fullname_media_delete:    'Media delete',
      permission_fullname_embeds_read:     'Embed codes read',
      permission_fullname_embeds_write:    'Embed codes write',
      permission_fullname_embeds_delete:   'Embed codes delete',
      permission_fullname_accounts_read:   'Accounts read',
      permission_fullname_accounts_write:  'Accounts write',
      permission_fullname_accounts_delete: 'Accounts delete',
    },
    users_form:                {
      page_header_title_add:        'Adding new client',
      input_l_username:             'Email',
      input_l_name:                 'Full name',
      input_l_phone:                'Phone number',
      input_l_website:              'Website',
      input_l_role:                 'Role',
      input_l_password_placeholder: 'If left empty, password won\'t change',
      input_l_status:               'Account status',
      input_l_password:             'Password',
      input_l_settings:             'Additional settings (you can select many)',
      page_header_action_cancel:    'Cancel',
      page_header_action_save:      'Save',

    },
    ad_add_page:               {
      ad_added: 'Ad added.',
    },
    ad_edit_page:              {
      changes_saved: 'Changes saved.',
    },
    ad_schedules_add_page:     {
      ad_added: 'Ad schedule added.',
    },
    ad_schedules_edit_page:    {
      changes_saved: 'Changes saved.',
    },
    ad_form:                   {
      ad_schedule_ads_empty:          'At least one ad tag should be added.',
      ad_schedule_timeoffset_example: 'Acceptable time formats: XX% (10%), MM:SS (00:12), start, end.',
      ad_schedule_timeoffset_format:  'Acceptable time formats: XX% (10%), MM:SS (00:12), start, end.',
      ad_schedule_ads_count_info:     'If you order your ad tags based on CPM, we recommend to use one ad slot of given type (e.g. one preroll), order your ad tags in slot and define how many ads player should play from slot.',
      add_schedules_error:            'Please add at least one ad break.',
      add_links_to_ad_files_error:    'Please add at least one ad tag.',
      desktop_input_l:                'Desktop',
      desktop_tooltip_text:           'This ads will be used to play on desktop devices. If empty, no ads will be used for desktop devices.',
      mobile_input_l:                 'Mobile',
      mobile_tooltip_text:            'This ads will be used to play on mobile devices. If empty, no ads will be used for mobile devices.',
      desktop_mobile_input_l:         'Desktop and mobile',
      desktop_mobile_tooltip_text:    'This ads will be used to play on desktop and mobile devices. If empty, no ads will be used for desktop and mobile devices.',
      input_action_delete:            'Delete',
      validator:                      'Field must be an URL or string.',
      action_add_waterfall:           'Add an ad tag',
      action_add_ad_schedule:         'Add an ad break',
      page_header_title_add:          'New ad',
      page_header_title_add_schedule: 'New ad schedule',
      modal_confirm_delete_t:         'Delete',
      modal_confirm_delete_c:         'Are you sure you want to delete',
      modal_confirm_delete_ok:        'ad deleted.',
      page_header_action_delete:      'Delete',
      page_header_action_cancel:      'Cancel',
      page_header_action_save:        'Save',
      input_l_ad_name:                'Ad name',
      checkbox_l_reuse_tags:          'Use the same ad tags on desktop and mobile',
      input_l_ad_schedule_name:       'Ad schedule name',
      section_header_ad_setup:        'Ad setup',
      toggle_l_ad_standard:           'Ad standard',
      toggle_l_ad_format:             'Ad format',
      toggle_ad_schedule:             'Ad schedule',
      select_ad_schedule_ad_break:    'Ad break',
      select_tag_type_vast:           'VAST/VMAP URL',
      select_tag_type_only_vast:      'VAST URL',
      select_tag_type_vpaid:          'VPAID URL',
      select_tag_type_vastxml:        'XML',
      select_tag_type_jsvar:          'JS variable',
      break_time_l:                   'Break timing',
      ads_count_l:                    'Number of ads to play in slot',
    },
    home_page:                 {
      modal_change_password_title:              'Change Password',
      modal_change_password_ok:                 'Change password',
      modal_change_password_cancel:             'Cancel',
      modal_change_password_old_password_wrong: 'Please provide proper old password',
      modal_change_password_success:            'Changes saved.',
      modal_change_password_old_password:       'Old password',
      modal_change_password_new_password:       'New password',
      modal_change_password_new_2_password:     'Re-enter new password',
    },
    analytics_page:            {
      page_header_title:                        'Reports',
      page_header_analytics_filter_platform:    'Platform',
      page_header_analytics_filter_platform_dm: 'Desktop and mobile',
      page_header_analytics_filter_platform_d:  'Desktop',
      page_header_analytics_filter_platform_m:  'Mobile',
      page_header_analytics_filter_date:        'Date range',
      page_header_analytics_refresh:            'Refresh stats',
      page_header_analytics_export:             'Export stats',
      page_header_analytics_export_ads:         'Export ads stats',
      page_header_analytics_export_ad_tags:     'Export ad tag detailed stats',
      page_header_analytics_export_videos:      'Export videos stats',
      render_options_select_all:                'All',
      section_header_videos:                    'Your videos',
      stats_card_videos_loads:                  'Player loads',
      stats_card_tooltip_videos_loads:          'Number of times player, with video, has been loaded on page.',
      stats_card_videos_sticky_close:           'Sticky player closes',
      stats_card_tooltip_videos_sticky_close:   'Number of clicks in close button on floating (sticky) player.',
      stats_card_videos_impressions:            'Impressions',
      stats_card_tooltip_videos_impressions:    'Number of times video has started to play.',
      stats_card_videos_finishes:               'Finishes',
      stats_card_tooltip_videos_finishes:       'Number of times video has been watched till its end.',
      stats_card_videos_errors:                 'Errors',
      stats_card_tooltip_videos_error:          'Number of errors registered for videos.',
      section_header_ads:                       'Your ads',
      stats_card_ads_impressions:               'Impressions',
      stats_card_tooltip_ads_impressions:       'Number of times ad has started to play.',
      stats_card_ads_first_impressions:         'First impressions',
      stats_card_tooltip_ads_first_impressions: 'Number of times first ad has started to play.',
      stats_card_ads_viewable_im:               'Viewable impressions',
      stats_card_tooltip_ads_viewable_im:       'Number of times when at least 50% of ad area is visible for at least 2 seconds.',
      stats_card_ads_finishes:                  'Finishes',
      stats_card_tooltip_ads_finishes:          'Number of times ad has been watched till its end.',
      stats_card_ads_vtr:                       'Completion rate',
      stats_card_tooltip_ads_vtr:               'Completion rate = Finishes / Impressions',
      stats_card_ads_clicks:                    'Clicks',
      stats_card_tooltip_ads_clicks:            'Number of times ad has been clicked.',
      stats_card_ads_skips:                     'Skips',
      stats_card_tooltip_ads_skips:             'Number of times ad has been skipped.',
      stats_card_ads_errors:                    'Errors',
      stats_card_tooltip_ads_errors:            'Number of errors registered for ads.',
      stats_card_ads_empty_callback:            'Run custom JS code',
      stats_card_tooltip_ads_empty_callback:    'Number of times custom JavaScript code was run, when no ad was returned by ad server (configurable in player\'s Ads tab).',
      stats_card_ads_empty:                     'No ad returned',
      stats_card_tooltip_ads_empty:             'Number of times no ad has been returned by ad server.',
      file_no_data_to_export:                   'No data to export.',
      section_header_ads_summary:               'Summary data',
      section_header_ads_details:               'Detailed data',
    },
    analytics_details_page:    {
      title:                             'Ad breaks details',
      empty_data:                        'The is no data',
      col_t_name:                        'Ad tag',
      missing_tag:                       'Deleted Ad Tag',
      col_t_name_tooltip:                'The value of ad tag',
      col_t_first_impression:            'First Impressions',
      col_t_first_impression_tooltip:    'Number of times first ad has started to play.',
      col_t_impression:                  'Impressions',
      col_t_impression_tooltip:          'Number of times ad has started to play.',
      col_t_finish:                      'Finishes',
      col_t_finish_tooltip:              'Number of times ad has been watched till its end.',
      col_t_click:                       'Clicks',
      col_t_click_tooltip:               'Number of times ad has been clicked.',
      col_t_skip:                        'Skips',
      col_t_skip_tooltip:                'Number of times ad has been skipped.',
      col_t_ad_error:                    'Errors',
      col_t_ad_error_tooltip:            'Number of errors registered for ads.',
      col_t_ad_empty:                    'No ad returned',
      col_t_ad_empty_tooltip:            'Number of times no ad has been returned by ad server.',
      col_t_ad_empty_callback:           'Run custom JS code',
      col_t_ad_empty_callback_tooltip:   'Number of times custom JavaScript code was run, when no ad was returned by ad server (configurable in player\'s Ads tab).',
      col_t_viewable_impression:         'Viewable impressions',
      col_t_viewable_impression_tooltip: 'Number of times when at least 50% of ad area is visible for at least 2 seconds.',
      col_t_vtr:                         'Completion rate',
      col_t_vtr_tooltip:                 'Completion rate = Finishes / Impressions',
    },
    playlist_form_page:        {
      added:  'Embed added',
      edited: 'Embed edited',
    },
    player_add_page:           {
      player_added: 'Player added.',
    },
    player_edit_page:          {
      changes_saved: 'Changes saved.',
    },
    player_form:               {
      sample_video_title:    'Sample video title',
      page_header_title_add: 'New player',

      modal_confirm_delete_t:                              'Delete',
      modal_confirm_delete_c:                              'Are you sure you want to delete',
      modal_confirm_delete_ok:                             'player deleted.',
      page_header_action_delete:                           'Delete',
      page_header_action_cancel:                           'Cancel',
      page_header_action_duplicate:                        'Duplicate',
      page_header_action_save:                             'Save',
      input_l_sticky_player_mode:                          'Sticky player size mode',
      input_l_sticky_player_mode_tooltip:                  'In "Simple" mode, sticky player on mobile takes 100% screen width and is sticked to top / bottom of the screen. In "Extended" mode, you can fully control sticky player size.',
      sticky_mode_simple:                                  'Simple',
      sticky_mode_extended:                                'Extended',
      input_l_player_name:                                 'Player name',
      input_l_minWidth:                                    'Player min. width (in pixels)',
      input_l_maxWidth:                                    'Player max. width (in pixels)',
      input_l_maxWidthP:                                   'Player width relative to screen width (in %)',
      input_l_heightMobileP:                               'Player height on mobile, relative to screen height (in %)',
      input_l_vMargin_sticky:                              'Sticky player distance from top / bottom screen edge (in pixels)',
      input_l_hMargin_sticky:                              'Sticky player distance from left / right screen edge (in pixels)',
      input_l_minWidth_sticky:                             'Sticky player min. width on desktop (in pixels)',
      input_l_maxWidth_sticky:                             'Sticky player max. width on desktop (in pixels)',
      input_l_maxWidthP_sticky:                            'Sticky player width on desktop, relative to screen width (in %)',
      input_l_heightMobileP_sticky:                        'Sticky player height on mobile, relative to screen height (in %)',
      input_l_sticky_desktop_width:                        'Sticky player width on desktop (in pixels)',
      input_l_sticky_desktop_width_percent:                'Sticky player width on desktop, relative to screen width (in %)',
      input_l_sticky_mobile_width:                         'Sticky player width on mobile (in pixels)',
      input_l_sticky_mobile_width_tooltip:                 'Can be empty. If empty, percentage width will be used.',
      input_l_sticky_mobile_width_percent:                 'Sticky player width on mobile, relative to screen width (in %)',
      input_l_sticky_mobile_height:                        'Sticky player height on mobile (in pixels)',
      input_l_sticky_mobile_height_tooltip:                'Can be empty. If empty, percentage height will be used.',
      input_l_sticky_mobile_height_percent:                'Sticky player height on mobile, relative to screen height (in %)',
      section_header_player_size:                          'General player size and position',
      input_l_player_size:                                 'Player size',
      player_aspect_ratio:                                 'Player aspect ratio',
      aspect_ratio_auto:                                   'Auto',
      aspect_ratio_16_9:                                   '16:9',
      aspect_ratio_4_3:                                    '4:3',
      aspect_ratio_1_1:                                    '1:1',
      aspect_ratio_9_16:                                   '9:16',
      player_size_responsive:                              'Responsive',
      player_size_fixed:                                   'Fixed',
      input_l_player_width:                                'Player width (in pixels)',
      section_header_playback:                             'Playback',
      select_l_autoplay:                                   'Autoplay',
      select_tooltip_autoplay:                             'If you turn on \'Autoplay\', we recommend to select \'Mute on start\' so your video would not be blocked by web browsers.',
      autoplay_off:                                        'Off',
      autoplay_on:                                         'On',
      autoplay_in_view:                                    'In view',
      section_header_controls:                             'Player controls',
      show_controls:                                       'Show controls',
      mute_on_start:                                       'Mute player on start',
      mute_on_start_tooltip:                               'If you turn on \'Autoplay\', we recommend to select \'Mute on start\' so your video would not be blocked by web browsers.',
      mute_google:                                         'Mute for Google traffic',
      mute_homepage:                                       'Mute for homepage traffic',
      mute_homepage_tooltip:                               'Force mute when document.referrer is the root URL (/) of the current origin (same protocol, hostname and port), ignoring query parameters and fragments. A referrer containing another page path or a different origin, or an unavailable referrer, leaves the configured mute state unchanged.',
      mute_homepage_warning:                               'Warning: If the site sets the Referrer-Policy: origin header, the player treats visits from any page on the same origin as homepage visits. It therefore starts muted even after navigating from another page on the site.',
      mute_ios:                                            'Mute for iOS devices',
      mute_ios_tooltip:                                    'Force mute the player when the visitor comes from iOS devices, even if the player is set to unmuted.',
      mute_google_tooltip:                                 'Force mute the player when the visitor comes from Google (search, discovery, news), even if the player is set to unmuted.',
      section_header_player_seo_data:                      'SEO metadata',
      include_seo_metadata:                                'Include SEO metadata from video file',
      include_seo_metadata_info:                           'Player will load on page, SEO metadata of published video file: name, duration, description, video URL, poster URL.',
      block_playback_outside_viewport:                     'Pause playback when player is outside of viewport',
      block_playback_outside_viewport_info:                'Playback is paused when player is not visible to page visitor, and auto resumed when player is visible.',
      pip:                                                 'Picture in picture',
      video_time:                                          'Video time',
      seek_buttons:                                        'Seek buttons',
      seek_back:                                           'Seek back',
      seek_forward:                                        'Seek forward',
      section_header_browser_fixes:                        'Web browser fixes',
      selectbox_ad:                                        'Allow ads to run in this player',
      selectbox_ad_placeholder:                            'Select ad',
      checkbox_adblock:                                    'Block video playback if adblock is enabled',
      checkbox_force_skip_button:                          'Show custom ad skip button (even if ad is not skippable)',
      checkbox_apply_browser_fixes:                        'Allow player to apply web browser fixes',
      input_l_adblock_msg:                                 'Adblock message',
      input_l_skip_button_text:                            'Skip button default text',
      input_l_skip_button_text_counter:                    'Skip button time offset text (use {seconds} to display time)',
      input_l_skip_button_offset:                          'Skip button time offset (in seconds)',
      section_header_ad_handling:                          'Ad format player will play',
      input_tooltip_adformat:                              'Selecting \'Outstream\' format remember to turn on \'Autoplay\', otherwise your ad won\'t play.',
      input_l_outstream_type:                              'Outstream type player will play',
      input_l_player_position_sticky:                      'Screen corner (for sticky player location)',
      player_position_br:                                  'Bottom right',
      player_position_bl:                                  'Bottom left',
      player_position_tr:                                  'Top right',
      player_position_tl:                                  'Top left',
      input_l_player_behaviour:                            'Player behaviour after in content ad finish to play',
      input_l_close_btn:                                   'Player close button',
      input_l_close_btn_sticky:                            'Sticky player close button',
      tab_ads:                                             'Ads',
      tab_customization:                                   'Customization',
      tab_setup:                                           'Setup',
      section_header_desktop_sticky_corner:                'Desktop sticky player screen corner',
      section_header_mobile_sticky_corner:                 'Mobile sticky player screen corner',
      section_header_sticky_size:                          'General sticky player size',
      input_l_player_position_mode:                        'Player position mode',
      links_refresh_player:                                'Refresh preview to see your changes',
      pip_disabled_tooltip:                                'Picture-in-picture is available only for player \'Player position = Page content\'.',
      browser_fixes_tooltip:                               'Some web browsers got bugs not allowing player to work properly. By enabling \'Web browser fixes\' player can fix mentioned bugs, but it can also break given website.',
      sectionp_layer_injections:                           'Player injection into page',
      custom_player_injections_tooltip_p1:                 'By default, player will appear on page in place where you paste its code snippet.',
      custom_player_injections_tooltip_p2:                 'You can customize this behaviour, so player would appear on page in differen place than you’ve pasted its code snippet.',
      custom_player_injections_query_selector:             'Query selector of the page element to inject player into',
      custom_player_injections_query_selector_tooltip:     'JavaScript querySelector (e.g. HTML element id or class names).',
      custom_player_injections_inject_method:              'Inject method',
      custom_player_injections_append_child:               'Inside element',
      custom_player_injections_inplace:                    'In place of embedded script',
      custom_player_injections_before_begin:               'Before element',
      custom_player_injections_before_end:                 'After last child of element',
      custom_player_injections_after_begin:                'Before first child of element',
      custom_player_injections_after_end:                  'After element',
      custom_player_injections_query_selector_placeholder: '#element-id .element-class',
      section_header_player_close_button:                  'Close button',
      show_players_close_button:                           'Show player close button, with delay (in seconds)',
      use_player_close_button:                             'Use player close button to skip ads',
      section_header_branding_top_right_corner_logo:       'Top-right corner logo',
      section_header_branding_bottom_bar:                  'Bottom bar',
      branding_text:                                       'Text',
      branding_link:                                       'Link',
      branding_image:                                      'Image',
      branding_corner_text_info:                           'Text which will appear on logo hover.',
      branding_corner_link_info:                           'Link which will be opened when user will click on logo.',
      branding_corner_image_info:                          'Image which will appear in player top-right corner. Recommended image size is 48x48px (square).',
      branding_bottom_bar_text_info:                       'Text which will appear on bottom bar.',
      branding_bottom_bar_link_info:                       'Link which will be opened when user will click on text on bottom bar.',
      branding_bottom_bar_image_info:                      'Image which will appear on bottom bar, after text. Recommended image size is 48x48px (square).',
      branding_default:                                    'Default',
      branding_disabled:                                   'Disabled',
      branding_custom:                                     'Custom',
      branding_on:                                         'On',
      branding_off:                                        'Off',
      hide_player_after_ad_finish:                         'For outstream ads, automatically hide player after ad finished playing',
      wait_for_privacy_consent:                            'Delay player to wait for privacy consent (in seconds)',
      custom_player_behaviour:                             'Custom player behaviour depending on ad status',
      custom_player_behaviour_tooltip:                     'If you use VMAPs (multiple ads per one video), we do not recommend to enable below behaviours as they are dedicated to work with single preroll ads.',
      disable_autoplay_if_no_ad:                           'Disable autoplay, if no ad was returned by ad server',
      hide_player_if_no_ad:                                'Hide player on page, if no ad was returned by ad server',
      disable_sticky_if_empty_or_finished:                 'Disable sticky mode, if no ad was returned by ad server, or ad finished to play',
      switch_to_sticky_if_outside_viewport:                'Switch to sticky mode when the player is outside the viewport',
      sticky_outside_viewport_timeout:                     'Delay before switching to sticky (milliseconds; 0 = immediately, or earlier when scrolled past)',
      sticky_outside_viewport_timeout_invalid:             'Enter a whole number between 0 and 2147483647',
      run_alternative_player_or_ad_config_if_no_ad:        'Run alternative ad config, if no ad was returned by ad server',
      player_config:                                       'Player config',
      player_config_placeholder:                           'Select video player',
      player_config_secondary_info_autoplay:               'Autoplay',
      player_config_info_ads:                              'ads',
      player_config_info_position:                         'Position in',
      player_config_info_width:                            'Width',
      player_config_info_screen_width:                     'Screen width',
      run_custom_js:                                       'Run custom JavaScript code, if no ad was returned by ad server',
    },
    players_page:              {
      page_header_title:          'Players',
      add_new_player_cta:         'Add new player',
      col_t_name:                 'Name',
      col_t_ad_type:              'Ad format',
      col_t_aspect_ratio:         'Aspect ratio',
      col_t_ad:                   'Ad',
      aspect_ratio_auto:          'Auto',
      ad_type_instream:           'Instream',
      ad_type_outstream:          'Outstream',
      actions_publish:            'Embed',
      col_t_actions:              'Actions',
      actions_duplicate:          'Duplicate',
      actions_edit:               'Edit',
      actions_delete:             'Delete',
      modal_confirm_delete_t:     'Delete',
      modal_confirm_delete_c:     'Are you sure you want to delete',
      modal_confirm_delete_ok:    'player deleted.',
      modal_confirm_duplicate_t:  'Duplicate',
      modal_confirm_duplicate_c:  'Are you sure you want to duplicate',
      modal_confirm_duplicate_ok: 'player duplicated.',
    },
    video_form:                {
      no_video_uploaded:               'No video uploaded.',
      video_added:                     'Video added.',
      changes_saved:                   'Changes saved.',
      add_links_to_video_files:        'Add links to video files.',
      page_header_title_add:           'New video',
      modal_confirm_delete_t:          'Delete',
      modal_confirm_delete_c:          'Are you sure you want to delete',
      modal_confirm_delete_ok:         'video deleted.',
      page_header_action_delete:       'Delete',
      page_header_action_cancel:       'Cancel',
      page_header_action_save:         'Save',
      page_header_action_download:     'Download video',
      input_l_video_file:              'Video file',
      input_l_video_name:              'Video name',
      input_l_youtube_link:            'YouTube video URL',
      input_l_video_description:       'Video description',
      input_l_video_categories:        'Video categories',
      input_l_video_duration:          'Video duration (seconds)',
      input_l_video_duration_tooltip:  'Float values allowed (e.g. 120.5). Use period as decimal separator.',
      validation_float_format:         'Please enter a valid number (use period as decimal separator, e.g. 120.5).',
      input_l_video_poster:            'Video poster URL',
      file_uploaded:                   'File uploaded.',
      modal_confirm_delete_file:       'Are you sure you want to delete this file?',
      modal_confirm_delete_file_ok:    'File deleted.',
      actions_delete:                  'Delete',
      upload_form_1row:                'Click here, or drag file to this area to upload it.',
      upload_form_2row:                'Supported file format: mp4.',
      size_limit:                      'Maximum upload file size:',
      upload_error_file_size:          'Cannot upload the file. File size too large. Maximum upload file size is:',
      alert_youtube_video_restriction: 'You can download videos up to 10 minutes. Longer videos might result in error.',
      alert_youtube_video_downloading: 'Downloading video, please stay on this page until finished.',
    },
    video_page:                {
      page_header_title:           'Videos',
      add_new_video_cta:           'Add new video',
      add_new_video_file_cta:      'Upload from file',
      add_new_video_yt_cta:        'Download from YouTube',
      add_new_video_cta_upload:    'Upload a file',
      add_new_video_cta_register:  'Register URL to a file',
      col_t_name:                  'Name',
      col_t_poster:                'Poster',
      col_t_size:                  'Size',
      col_t_type:                  'Type',
      col_v_type_external:         'External URL',
      col_v_type_hosted:           'Hosted file',
      col_t_status:                'Status',
      col_t_publish_date:          'Published',
      col_t_create_date:           'Created',
      col_t_duration:              'Duration',
      col_t_actions:               'Actions',
      actions_publish:             'Embed',
      actions_edit:                'Edit',
      actions_detect_duration:     'Detect duration',
      actions_detecting_duration:  'Detecting...',
      actions_generate_poster:     'Generate poster',
      actions_delete:              'Delete',
      modal_confirm_delete_t:      'Delete',
      modal_confirm_delete_c:      'Are you sure you want to delete',
      modal_confirm_delete_ok:     'video deleted.',
      modal_confirm_delete_noname: 'Video deleted.',
      delete_video_in_progress:    'This video is currently being deleted.',
    },
    video_add_media_url_modal: {
      modal_t:                             'Add link to video file',
      modal_cancel_cta:                    'Cancel',
      modal_confirm_cta:                   'Add',
      modal_input_l_file:                  'Video file link',
      modal_input_l_resolution:            'Resolution label',
      modal_select_placeholder_resolution: 'Select video resolution label',
      modal_select_res_option_default:     'Default',
      modal_select_res_option_low:         'Low',
      modal_select_res_option_medium:      'Medium',
      modal_select_res_option_high:        'High',
    },
    video_publish_modal:       {
      modal_t:                           'Generate embed code',
      modal_secondary_info_autoplay:     'Autoplay',
      modal_secondary_info_position:     'Position in',
      modal_cancel_cta:                  'Close',
      modal_notification_code_copied:    'Code snippet copied to clipboard.',
      modal_confirm_cta:                 'Copy code snippet to clipboard',
      modal_input_l_video:               'Video',
      modal_input_l_player:              'Player',
      modal_input_placeholder_player:    'Select video player',
      modal_input_l_code:                'Code snippet',
      modal_secondary_info_width:        'Width',
      modal_secondary_info_screen_width: 'Screen width',
      modal_embed_info_video:            'Video',
      modal_ad_format_instream:          'instream',
    },
    authenticated_page:        {
      no_access_header:          'You don\'t have access to Veedmo panel',
      no_access_subheader:       'Contact your administrator to get access.',
      reports_link:              'Reports',
      players_link:              'Players',
      ads_link:                  'Ads',
      users_link:                'Users',
      media_group:               'Media',
      videos_link:               'Videos',
      veedmo_admin:              'Veedmo admin',
      veedmo_users_link:         'Clients\' accounts',
      veedmo_user_accounts_link: 'Clients\' subaccounts',
      veedmo_settings_link:      'Settings',
      logout_button:             'Sign out',
      playlists_link:            'Playlists',
      get_embed_code_link:       'Generate embed code',
      embeds_link:               'Embed codes',
      change_password:           'Change password',
      sfa:                       'Two-factor authentication',
    },
    system_404_page:           {
      message: 'Something went wrong',
      login:   'Sign in to your account',
    },
    register:                  {
      account_created: 'Account Created!!',
      account_error:   'Account already exists or not all fields are filled.',
    },
    generic_form:              {
      required:             'Required.',
      number:               'Value must be a number.',
      email:                'Email format is incorrect.',
      correct_form:         'Please correct the form.',
      auth_error:           'Passwords that you entered is incorrect.',
      password_confirm:     'The two passwords that you entered do not match!',
      password_validation:  'Password must be minimum 8 characters.',
      validation_url:       'Must be an URL.',
      placeholder_url:      'https://www.domain.com/link',
      placeholder_string:   'Put your value here',
      placeholder_url_yt:   'https://www.youtube.com/watch?v=...',
      placeholder_text:     'Text',
      placeholder_select:   'Select',
      placeholder_password: 'Password',

      msg_info_changes_propagation_time: 'All changes can take up to 1 minute to propagate.',
    },
    generic_common:            {
      request_error: 'There was a problem with request.',
      error_401:     'You dont have permission to perform this action',
    },
  },
  pl: {},
};
